





























































































































































































































import { Component, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { mapGetters } from 'vuex'
import GeofenceModel from '@/_models/GeofenceModel'
import GeofenceAddEditModal from '@/components/geofence/partials/GeofenceAddEditModal.vue'
import GeofenceMapAdjust from '@/components/geofence/partials/GeofenceMapAdjust.vue'
import GeofenceCSVModal from '@/components/geofence/partials/GeofenceCSVModal.vue'

// Interface
import { IPageFilterModel } from '@/_interfaces'

// Shared
import FilterDropdown from '@/components/shared/FilterDropdown.vue'
import TablePagination from '@/components/shared/TablePagination.vue'

// Common
import NotFound from '@/components/common/NotFound.vue'
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

import * as DownloadCsv from 'vue-json-csv'
import { Filter } from '@/_utils/filter'

@Component({
  components: {
    GeofenceAddEditModal,
    GeofenceMapAdjust,
    GeofenceCSVModal,
    DownloadCsv,
    FilterDropdown,
    NotFound,
    TablePagination,
  },
  computed: {
    ...mapGetters('common', {
      fullThumbImageUrl: 'fullThumbImageUrl',
    }),
    ...mapGetters('geofences', {
      canEdit: 'canEdit',
    }),
    ...mapGetters('geofences', {
      canDelete: 'canDelete',
    }),
  },
})
export default class GeofenceList extends mixins(TableSortMixin) {
  // data
  filterUtilTableSort: any = new Filter('filter_geofence_list_table_sort')
  filterUtilPage: any = new Filter('filter_geofencelist_page')
  pageFilters: IPageFilterModel = {
    currentPage: 1,
    perPage: 10,
    selectedFilter: 'name',
    searchQuery: '',
  }
  numofPage: number = 1
  selected: GeofenceModel = new GeofenceModel()
  isFormModalActive: boolean = false
  isImportCsvModalActive: boolean = false
  isMapAdjustActive: boolean = false

  uploadFile: any = null
  mapAdjustData: any = {}
  canEdit!: boolean
  canDelete!: boolean

  filedNameLUT: any = {
    _id: 'UUID',
    name: 'label.geofence_name',
  }

  // Import/Export csv setting
  csvFields: any = [
    '_id',
    'name',
    'card_ids',
    'geofence_users',
    'geofence_sw_lat',
    'geofence_sw_lon',
    'geofence_ne_lat',
    'geofence_ne_lon',
    'geofence_angle',
    'geofence_map_zoom',
    'geofence_opacity',
  ]

  // computed
  get geofences(): GeofenceModel[] {
    const geofences = this.$store.state.geofences.all.items
    this.numofPage = Math.ceil(geofences.length / this.pageFilters.perPage)

    return geofences
  }

  get geofencesCSVData() {
    return this.geofences.map((item: GeofenceModel) => ({
      ...item,
      card_ids: item.geofence_users.map(
        (user) => user.san_id || user.major + '/' + user.minor
      ),
    }))
  }

  get isLoading(): boolean {
    return this.$store.state.geofences.loading
  }

  get filteredData(): GeofenceModel[] {
    const targetField: string = this.pageFilters.selectedFilter
    if (!this.geofences) {
      return []
    }

    return this.geofences.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.pageFilters.searchQuery.toLowerCase()) !== -1 ||
        item._id === this.pageFilters.searchQuery // Can search by uuid
      )
    })
  }

  @Watch('isFormModalActive')
  watchFormModalActive(): void {
    this.uploadFile = null
  }

  handleOpenModalEdit(data: GeofenceModel): void {
    this.isFormModalActive = true
    // Deepclone because in swatcher we have assign value into space variable
    const geofence = JSON.parse(JSON.stringify(data))
    if (!Object.keys(geofence.geofence_styles).length) {
      geofence.geofence_styles = {
        bg_card_enter: 'success',
        bg_card_exit: 'danger',
      }
    }

    this.selected = geofence
  }

  handleOpenModalAdd(): void {
    this.isFormModalActive = true
    this.selected = new GeofenceModel()
  }

  handleOpenModalImportCSV(): void {
    this.isImportCsvModalActive = true
  }

  handleOpenModelAdjustMap(isOpen: boolean): void {
    if (isOpen) {
      this.mapAdjustData.name = this.selected.name
      // Default location is Tokyo Japan.
      this.mapAdjustData._id = this.selected._id
      this.mapAdjustData.geofence_sw_lat =
        this.selected.geofence_sw_lat || 35.65577696083861
      this.mapAdjustData.geofence_sw_lon =
        this.selected.geofence_sw_lon || 139.8335337638855
      this.mapAdjustData.geofence_ne_lat =
        this.selected.geofence_ne_lat || 35.65790646200456
      this.mapAdjustData.geofence_ne_lon =
        this.selected.geofence_ne_lon || 139.83752589941025
      this.mapAdjustData.geofence_angle = this.selected.geofence_angle || 0
      this.mapAdjustData.geofence_map_zoom =
        this.selected.geofence_map_zoom || 16
      this.mapAdjustData.geofence_opacity = this.selected.geofence_opacity || 50
      this.isMapAdjustActive = true
    }
  }

  handleCloseModal() {
    this.isFormModalActive = false
  }

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  confirmCustomDelete(data): void {
    this.selected = data
    this.$buefy.dialog.confirm({
      title: this.$t('delete') as string,
      message: this.$t('messages.are_you_sure_want_to_delete') as string,
      confirmText: this.$t('delete') as string,
      cancelText: this.$t('button.cancel') as string,
      type: 'is-danger',
      hasIcon: true,
      onConfirm: async () => {
        this.processDelete(data)
      },
    })
  }

  processDelete(data): void {
    this.selected = data
    const index = this.geofences.indexOf(this.selected)
    this.$store.dispatch('geofences/deleteOne', this.selected).then(() => {
      this.selected = new GeofenceModel()
      this.$buefy.toast.open(this.$t('messages.delete_success') as string)
    })
  }

  goToActionPage(nameRoute: string, geofenceId: string) {
    this.$router
      .push({
        name: nameRoute,
        query: {
          type: 'geofence',
          geofence_id: geofenceId,
        },
      })
      .catch(() => false)
  }

  mapAjustDone(data): void {
    this.selected.geofence_sw_lat = data.geofence_sw_lat
    this.selected.geofence_sw_lon = data.geofence_sw_lon
    this.selected.geofence_ne_lat = data.geofence_ne_lat
    this.selected.geofence_ne_lon = data.geofence_ne_lon
    this.selected.geofence_angle = data.geofence_angle
    this.selected.geofence_map_zoom = data.geofence_map_zoom
    this.selected.geofence_opacity = data.geofence_opacity
    this.isMapAdjustActive = false
  }

  beforeDestroy() {
    this.filterUtilPage.save(this.pageFilters)
  }

  // After page created
  async created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    await this.$store.dispatch('geofences/getAll')
    this.$store.dispatch('users/getAll')
    this.$store.dispatch('floors/getAll')
  }
}
